export default __webpack_public_path__ + "static/media/imagem_01.2e10f73a.png";